import PaymentsRemoteDataSource from "../datasources/payments_remote_datasource";
import either, { left, right } from "../../../../lib/either";

const GetRelativeBalanceUseCase = () =>
  either(async () => {
    try {
      const response =
        await PaymentsRemoteDataSource.getRelativeBalanceInformation();
      return right(response.data);
    } catch (err) {
      return left(err);
    }
  });

export default GetRelativeBalanceUseCase;
